import { ProfileReportRequestDto, ProfileReportResponseDto } from '@diritto/common/account/dtos/profile-report.dtos';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class ProfileReportApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async isReported(profileId: number) {
    const res = await this.http.get<ProfileReportResponseDto>(`${this.url}/accounts/profiles/${profileId}/report`);
    return res.data;
  }

  async reportProfile(profileId: number, profileReportDto: ProfileReportRequestDto): Promise<ResponseDto> {
    const res = await this.http.post<ProfileReportRequestDto, ResponseDto>(
      `${this.url}/accounts/profiles/${profileId}/report`,
      profileReportDto,
    );
    return res.data;
  }
}
